import React from 'react';

import { PrivacyPolicy } from '../../components/privacy-policy/PrivacyPolicy';

export const PrivacyPolicyPage: React.FC = () => {
    return <PrivacyPolicy />;
};
